
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download/od",
      function () {
        return require("private-next-pages/download/od/index.tsx");
      }
    ]);
  